// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__U666J","summary":"CartItem_summary__enEcF","price":"CartItem_price__iLdaN","amount":"CartItem_amount__82UE5","actions":"CartItem_actions__PqDiY"};